import { SuccessAlert } from '../shared/icons/SuccessAlert'
import { Banner } from './Banner'

type SuccessProps = {
  title: string
  children: string
  handleClose?(): void
}

const Success = (props: SuccessProps) => {
  const { title, children, handleClose } = props
  return <Banner
    title={title}
    handleClose={handleClose}
    textColor="#0A2F19"
    borderColor='#27A555'
    backgroundColor='#F4FBF7'
    flag={<SuccessAlert />}
  >
    {children}
  </Banner>
}

export { Success }
